module.exports = __webpack_public_path__ + "static/media/10.02ecb245.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/10.JPG
// module id = 442
// module chunks = 0